import { render, staticRenderFns } from "./SystemBalanceLog.vue?vue&type=template&id=fb22cb1a&"
import script from "./SystemBalanceLog.vue?vue&type=script&lang=ts&"
export * from "./SystemBalanceLog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SystemBalanceLog.vue"
export default component.exports